import { getToken } from '@/utils/storage'; // getToken from cookie

export default {
  /**
   * 对Date的扩展，将 Date 转化为指定格式的String
   * @param {*} date 时间
   * @param {*} fmt  格式
   * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
   * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
   * (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
   * (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
   */
  formatTimeToStr(date, fmt) {
    if (!date) {
      return '';
    }
    fmt = fmt || 'yyyy-MM-dd';
    // 替换-为/，为了兼容ios
    if (typeof (date) === 'string' && date.indexOf('-') !== 0) date.replace(/-/g, '/');
    date = date ? new Date(date) : new Date();

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : (('00' + o[k]).substr(('' + o[k]).length)));
      }
    }
    return fmt;
  },
  formatTime(time) {
    function checkTime(i) {
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    }
    var date = new Date(time);
    return checkTime(date.getHours()) + ':' + checkTime(date.getMinutes());
  },
  // 去重
  reduceArr(Arr, id) {
    const obj = {};
    const peon = Arr.reduce((cur, next) => {
      obj[next[id]] ? '' : obj[next[id]] = true && cur.push(next);
      return cur;
    }, []);
    return peon;
  },
  getNowFormatDate() {
    var date = new Date();
    var seperator1 = '-';
    var month = date.getMonth() + 1;
    var strDate = date.getDate() - 1;
    if (month >= 1 && month <= 9) {
      month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate;
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },

  getupFormatDate(num, months) {
    var date = new Date();
    var month;
    var seperator1 = '-';
    if (months) {
      month = date.getMonth() - months;
    } else {
      month = date.getMonth();
    }

    var strDate;
    if (num === '-1') {
      strDate = date.getDate() - 1;
    } else {
      strDate = date.getDate() - 1;
    }

    if (month >= 1 && month <= 9) {
      month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate;
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  // 判断闰年
  // var dayMouth = [31, 28 + IsLeap(year), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  isLeap(year) {
    return (year % 100 === 0) ? ((year % 400 === 0) ? 1 : 0) : ((year % 4 === 0) ? 1 : 0);
  },

  // 指定属性递归找对应的对象
  toggleFilterTree(key, value, arr) {
    let obj = {};
    (function filterChildren(paramArr) {
      paramArr.forEach(item => {
        if (value === item[key]) {
          obj = item;
        } else if (item.childOrgList && item.childOrgList.length > 0) {
          filterChildren(item.childOrgList);
        }
      });
    })(arr);
    return obj;
  },

  // 指定属性,对象数组去重
  distinct(key, arr) {
    const result = [];
    const obj = {};
    for (const item of arr) {
      if (!obj[item[key]]) {
        result.push(item);
        obj[item[key]] = 1;
      }
    }
    return result;
  },

  // // 筛选路由
  // recursionRouter(userRouter = [], asyncRoutes = []) {
  //   var realRoutes = [];
  //   var allRouter = _.cloneDeep(asyncRoutes); // 深拷贝
  //   allRouter.forEach(v => {
  //     userRouter.forEach(item => {
  //       if (item.name === v.name) {
  //         if (item.childMenus && item.childMenus.length > 0) {
  //           v.children = recursionRouter(item.childMenus, v.children);
  //         }
  //         realRoutes.push(v);
  //       }
  //     });
  //   });
  //   return realRoutes;
  // },
  // 筛选路由
  mapRouter(userRouter = []) {
    function judgeChildren(userRouter) {
      userRouter.map(e => {
        if (e.children && e.children.length) {
          e.redirect = e.children[0].path;
          judgeChildren(e.children);
        } else {
          return;
        }
      });
    }
    judgeChildren(userRouter);
    return userRouter;
  },
  // 筛选路由
  redirectRouter(userRouter = [], v) {
    let flag = false;
    function judgeChildren(userRouter) {
      userRouter.forEach(e => {
        if (flag) {
          return;
        }
        if (e.path === v) {
          flag = true;
          return;
        } else if (e.children && e.children.length) {
          judgeChildren(e.children);
        }
      });
    }
    judgeChildren(userRouter);
    return flag;
  },

  // 数字转汉字 万以内
  SectionToChinese(section) {
    var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var chnUnitChar = ['', '十', '百', '千'];
    var strIns = '';
    var chnStr = '';
    var unitPos = 0;
    var zero = true;
    while (section > 0) {
      var v = section % 10;
      if (v === 0) {
        if (!zero) {
          zero = true;
          chnStr = chnNumChar[v] + chnStr;
        }
      } else {
        zero = false;
        strIns = chnNumChar[v];
        strIns += chnUnitChar[unitPos];
        chnStr = strIns + chnStr;
      }
      unitPos++;
      section = Math.floor(section / 10);
    }
    return chnStr;
  },
  // // 万以外
  // NumberToChinese(num) {
  //   var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  //   var chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
  //   var unitPos = 0;
  //   var strIns = '';
  //   var chnStr = '';
  //   var needZero = false;
  //   if (num === 0) {
  //     return chnNumChar[0];
  //   }
  //   while (num > 0) {
  //     var section = num % 10000;
  //     if (needZero) {
  //       chnStr = chnNumChar[0] + chnStr;
  //     }
  //     strIns = SectionToChinese(section);
  //     strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];
  //     chnStr = strIns + chnStr;
  //     needZero = (section < 1000) && (section > 0);
  //     num = Math.floor(num / 10000);
  //     unitPos++;
  //   }
  //   return chnStr;
  // },
  // 防抖=》使用场景：提交订单，搜素联想
  debounce(func, wait, immediate) {
    let timeout, result;
    return function() {
      const _self = this;
      const args = arguments;
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        const callNow = !timeout;
        timeout = setTimeout(function() {
          timeout = null;
        }, wait);
        if (callNow) result = func.apply(_self, args);
      } else {
        timeout = setTimeout(function() {
          func.apply(_self, args);
        }, wait);
      }
      return result;
    };
  },

  // 节流 =》拖拽场景，固定时间内只执行一次，避免频繁触发， 缩放场景: 监控浏览器的resize
  throttle(func, wait) {
    let timeout;
    return function() {
      const _self = this;
      const args = arguments;
      if (!timeout) {
        timeout = setTimeout(function() {
          timeout = null;
          func.apply(_self, args);
        }, wait);
      }
    };
  },

  /**
 * @param {string} val
 * @returns {string}
 */
  html2Text(val) {
    const div = document.createElement('div');
    div.innerHTML = val;
    return div.textContent || div.innerText;
  },

  filterProdectId(arr, name) {
    let prodectId = '';
    const deepSearch = (arr, name) => {
      for (var x of arr) {
        if (x.name === name) {
          prodectId = x.applicationId;
          break;
        } else if (x.childMenus && x.childMenus.length > 0) {
          deepSearch(x.childMenus, name);
        }
      }
    };
    deepSearch(arr, name);
    return prodectId;
  },

  // 筛选最高级别的机构
  compare(propertyName) {
    return function(object1, object2) {
      var value1 = object1[propertyName];
      var value2 = object2[propertyName];
      if (value2 > value1) {
        return -1;
      } else if (value2 < value1) {
        return 1;
      } else {
        return 0;
      }
    };
  },

  // 没有学校提示
  noSchoolMessage(shoolCode) {
    if (!shoolCode) {
      this.$msgbox({
        title: '提示',
        message: '请选择学校，若机构下没有学校，请先创建学校',
        confirmButtonText: '确定',
        type: 'warning'
      });
      return false;
    } else {
      return true;
    }
  },

  getParenthesesStr(text) {
    let result = '';
    if (text === '') { return result; }
    // let regex = /\{(.+?)\}/g;
    // let options = text.match(regex)
    // if (options) {
    //   let option = options[0]
    //   if (options) {
    //     result = option.substring(1, option.length - 1)
    //   }
    // }
    const options = text.split('{website}');
    result = options[1];
    return result;
  },
  fadeIn(elemt, speed) { // 淡入 0 ~ 1
    if (parseInt(elemt.style.opacity) === 0 || elemt.style.opacity !== '') {
      const speeds = speed || 16.6; // 默认速度为16.6ms
      var num = 0; // 累加器
      var timer = setInterval(function() {
        num++;
        elemt.style.opacity = num / 20;
        if (num >= 20) {
          clearInterval(timer);
        }
      }, speeds);
    }
  },
  fadeOut(elemt, speed) { // 淡出 1 ~ 0
    if (parseInt(elemt.style.opacity) === 1 || elemt.style.opacity === '') {
      const speeds = speed || 16.6; // 默认速度为16.6ms
      var num = 20; // 累剪器
      var timer = setInterval(function() {
        num--;
        elemt.style.opacity = num / 20;
        if (num === 0) {
          clearInterval(timer);
        }
      }, speeds);
    }
  },
  // 执行iframe中函数
  doIFrameFunc(v_mymethod, v_params, v_frmName) {
    if (document.getElementById(v_frmName)) {
      try {
        var fn = document.getElementById(v_frmName).contentWindow[v_mymethod];
        if (fn) {
          if (v_params == null) {
            return fn();
          } else {
            return fn.apply(this, v_params);
          }
        }
      } catch (error) {
        return null;
      }
      return null;
    }
  },
  urlAddToken(val, type) {
    if (val && val.substr(-6) === 'token=' && getToken()) {
      return `${val}${encodeURI(getToken())}`;
    } else if (val && val.substr(-7) === 'userNo=' && getToken()) {
      return `${val}${encodeURI(getToken())}`;
    } else if (type) {
      return false;
    } else {
      return val ? `${val}` : 'javascript:void(0);';
    }
  }
};
